import React from "react";
import { connect } from "react-redux";
import MSectionCollection, { MSECTION_MODE_TAB } from "components/Shared/MSectionCollection";
import PersonalInfo from "components/User/Profile/PersonalInfo";
import TwoFactorSettings from "components/User/Profile/TwoFactorSettings";
import WatchedCaseEvents from "components/User/WatchedCaseEvents";
import { userHasRight } from "selectors/rights";
import { INSPECTION_EVENT_WATCH, APPRAISAL_EVENT_WATCH, USER_MULTI_FACTOR_REQUIRED } from "typeConstants/rights";
import Appearance from "./Appearance.tsx";

interface ProfileProps {
  internetUserId: number;
  hasInspectionWatchRight: boolean;
  hasAppraisalWatchRight: boolean;
  hasMultiFactorRequiredRight: boolean;
}

const Profile = (props: ProfileProps) => {
  let sections = [
    {
      title: "Personal Info",
      children: (<PersonalInfo />)
    },
  ];

  if (props.hasMultiFactorRequiredRight) {
    sections.push({
      title: "Two Factor Settings",
      children: (<TwoFactorSettings canAdd={true} />)
    });
  }
  if (props.hasInspectionWatchRight || props.hasAppraisalWatchRight) {
    sections.push({
      title: "Watched Case Events",
      children: (<WatchedCaseEvents internetUserId={props.internetUserId} />)
    });
  }

  sections.push({
    title: "Appearance",
    children: (<Appearance />)
  });

  return (
    <MSectionCollection
      defaultMode={MSECTION_MODE_TAB}
      tabModeCollapsible={false}
      persistTabs={true}
      disableModeChanging={true}
      sections={sections}
    />
  );
};

const mapStateToProps = state => ({
  internetUserId: state.user.internetUserId,
  hasInspectionWatchRight: userHasRight(INSPECTION_EVENT_WATCH)(state),
  hasAppraisalWatchRight: userHasRight(APPRAISAL_EVENT_WATCH)(state),
  hasMultiFactorRequiredRight: userHasRight(USER_MULTI_FACTOR_REQUIRED)(state),
});

export default connect(mapStateToProps)(Profile);
